/**
 * SOY Müşteri Soruları widget'ı — sağ alt köşe balonu.
 *
 * Asenkron: müşteri soru bırakır, yanıt e-posta ile gelir + sitede "Sorularım"
 * sekmesinde görünür (canlı sohbet DEĞİL — biz panelden cevaplarız).
 *
 * Görünümler:
 *   ask    → soru formu
 *   mine   → müşterinin konuşma listesi (girişli müşteride)
 *   thread → tek konuşma: ürün kartı + mesaj baloncukları + yanıt kutusu
 *   done   → "sorunuz ulaştı" ekranı
 *
 * Yapılandırma #soy-support-widget elementinin data-* alanlarından okunur
 * (snippets/support-widget.liquid Liquid'den doldurur).
 *
 * Girişli müşteride e-posta SORULMAZ; sunucu customer id ile Shopify'dan
 * doğrular (tarayıcıdan gelen e-postaya güvenilmez).
 */
(function () {
  "use strict";

  var root = document.getElementById("soy-support-widget");
  if (!root || root.dataset.mounted) return;
  root.dataset.mounted = "1";

  var cfg = {
    apiUrl: (root.dataset.apiUrl || "").replace(/\/$/, ""),
    storeId: root.dataset.storeId || "",
    customerId: root.dataset.customerId || "",
    customerName: (root.dataset.customerName || "").trim(),
    customerTs: root.dataset.customerTs || "",
    customerSig: root.dataset.customerSig || "",
    productId: root.dataset.productId || "",
    productHandle: root.dataset.productHandle || "",
    productTitle: root.dataset.productTitle || "",
  };
  if (!cfg.apiUrl || !cfg.storeId) return;

  var isLoggedIn = !!cfg.customerId;
  var firstName = cfg.customerName ? cfg.customerName.split(" ")[0] : "";
  // "Sorularım" yalnızca imzalı (girişli) müşteride — imza olmadan sunucu 403
  // döner, sekmeyi göstermek anlamsız olur.
  var canSeeHistory = isLoggedIn && !!cfg.customerSig && !!cfg.customerTs;

  // ---------------------------------------------------------------- stiller
  var css =
    '#soy-sw-btn{position:fixed;right:18px;bottom:18px;z-index:9998;width:54px;height:54px;' +
    "border-radius:50%;border:none;background:#1a1a1a;color:#fff;cursor:pointer;display:flex;" +
    "align-items:center;justify-content:center;box-shadow:0 4px 16px rgba(0,0,0,.22);" +
    "transition:transform .18s ease}" +
    "#soy-sw-btn:hover{transform:scale(1.06)}" +
    "#soy-sw-btn:focus-visible{outline:2px solid #1a1a1a;outline-offset:3px}" +
    "#soy-sw-btn svg{width:24px;height:24px}" +
    '#soy-sw-panel{position:fixed;right:18px;bottom:84px;z-index:9999;width:360px;max-width:calc(100vw - 36px);' +
    "background:#fff;border:1px solid #e2ddd6;box-shadow:0 12px 40px rgba(0,0,0,.16);" +
    "font-family:inherit;color:#1a1a1a;display:none}" +
    "#soy-sw-panel[data-open]{display:block}" +
    "#soy-sw-head{padding:16px 18px;border-bottom:1px solid #ece8e2;display:flex;" +
    "align-items:flex-start;justify-content:space-between;gap:10px}" +
    "#soy-sw-head h2{margin:0;font-size:15px;font-weight:600;letter-spacing:.02em}" +
    "#soy-sw-head p{margin:4px 0 0;font-size:12px;line-height:1.5;color:#7a736c}" +
    "#soy-sw-close{background:none;border:none;cursor:pointer;padding:2px;color:#7a736c;line-height:0}" +
    "#soy-sw-close svg{width:16px;height:16px}" +
    "#soy-sw-body{padding:16px 18px 18px}" +
    ".soy-sw-ctx{margin:0 0 14px;padding:8px 10px;background:#f6f4f1;font-size:11.5px;" +
    "line-height:1.45;color:#5d564f}" +
    ".soy-sw-field{margin:0 0 11px}" +
    ".soy-sw-field label{display:block;font-size:11px;letter-spacing:.06em;text-transform:uppercase;" +
    "color:#8a827a;margin:0 0 5px}" +
    ".soy-sw-field input,.soy-sw-field textarea{width:100%;box-sizing:border-box;padding:9px 11px;" +
    "border:1px solid #ddd6cd;background:#fff;font-family:inherit;font-size:13.5px;color:#1a1a1a;border-radius:0}" +
    ".soy-sw-field textarea{min-height:96px;resize:vertical}" +
    ".soy-sw-field input:focus,.soy-sw-field textarea:focus{outline:none;border-color:#1a1a1a}" +
    ".soy-sw-consent{display:flex;gap:8px;align-items:flex-start;margin:0 0 14px;font-size:11.5px;" +
    "line-height:1.5;color:#6d665f}" +
    ".soy-sw-consent input{margin:2px 0 0;flex:0 0 auto}" +
    ".soy-sw-consent a{color:#1a1a1a}" +
    "#soy-sw-submit{width:100%;padding:12px;border:none;background:#1a1a1a;color:#fff;font-family:inherit;" +
    "font-size:12px;letter-spacing:.1em;text-transform:uppercase;cursor:pointer}" +
    "#soy-sw-submit[disabled]{opacity:.5;cursor:default}" +
    "#soy-sw-error{margin:10px 0 0;font-size:12px;line-height:1.5;color:#a33a2a}" +
    "#soy-sw-done{padding:26px 20px;text-align:center}" +
    "#soy-sw-done svg{width:34px;height:34px;color:#1a1a1a}" +
    "#soy-sw-done h3{margin:12px 0 6px;font-size:15px;font-weight:600}" +
    "#soy-sw-done p{margin:0;font-size:12.5px;line-height:1.6;color:#6d665f}" +
    ".soy-sw-linkbtn{background:none;border:none;padding:0;margin:14px 0 0;font-family:inherit;" +
    "font-size:12px;letter-spacing:.04em;text-transform:uppercase;color:#1a1a1a;cursor:pointer;" +
    "border-bottom:1px solid #1a1a1a}" +
    "#soy-sw-hp{position:absolute;left:-9999px;width:1px;height:1px;opacity:0}" +
    "#soy-sw-tabs{display:flex;gap:18px;padding:0 18px;border-bottom:1px solid #ece8e2}" +
    ".soy-sw-tab{background:none;border:none;border-bottom:2px solid transparent;padding:10px 0;font-family:inherit;font-size:12px;letter-spacing:.04em;text-transform:uppercase;color:#8a827a;cursor:pointer}" +
    '.soy-sw-tab[aria-selected="true"]{color:#1a1a1a;border-bottom-color:#1a1a1a}' +
    // --- konuşma listesi ---
    "#soy-sw-history{padding:6px 0 8px;max-height:420px;overflow-y:auto}" +
    ".soy-sw-row{display:flex;gap:11px;align-items:center;width:100%;box-sizing:border-box;" +
    "padding:11px 18px;background:none;border:none;border-bottom:1px solid #f2efea;text-align:left;" +
    "font-family:inherit;cursor:pointer}" +
    ".soy-sw-row:last-child{border-bottom:none}" +
    ".soy-sw-row:hover{background:#faf9f7}" +
    ".soy-sw-row img{width:42px;height:54px;object-fit:cover;flex:0 0 auto;background:#f2efea}" +
    ".soy-sw-row-body{display:block;min-width:0;flex:1 1 auto}" +
    // display:block şart — inline span'de text-overflow:ellipsis çalışmaz
    ".soy-sw-row-title{display:block;margin:0 0 3px;font-size:12.5px;font-weight:600;line-height:1.35;" +
    "white-space:nowrap;overflow:hidden;text-overflow:ellipsis}" +
    ".soy-sw-row-snip{display:block;margin:0 0 4px;font-size:11.5px;line-height:1.4;color:#7a736c;" +
    "white-space:nowrap;overflow:hidden;text-overflow:ellipsis}" +
    ".soy-sw-row-meta{margin:0;display:flex;align-items:center;gap:7px;font-size:10px;color:#a09890}" +
    ".soy-sw-row-chev{flex:0 0 auto;color:#c4bdb4;font-size:15px;line-height:1}" +
    ".soy-sw-badge{padding:2px 7px;border-radius:9999px;font-size:9.5px;letter-spacing:.06em;text-transform:uppercase}" +
    ".soy-sw-badge--wait{background:#f3ede4;color:#8a6a3a}" +
    ".soy-sw-badge--done{background:#e4efe7;color:#3a6b4a}" +
    ".soy-sw-badge--closed{background:#f0eeeb;color:#8a827a}" +
    ".soy-sw-empty{padding:24px 18px;text-align:center;font-size:12.5px;color:#8a827a;line-height:1.6}" +
    // --- tek konuşma ---
    ".soy-sw-thread-top{display:flex;align-items:center;justify-content:space-between;gap:10px;" +
    "padding:9px 18px;border-bottom:1px solid #f2efea}" +
    ".soy-sw-back{background:none;border:none;padding:0;font-family:inherit;font-size:12px;" +
    "color:#1a1a1a;cursor:pointer}" +
    ".soy-sw-ticket{font-size:10px;letter-spacing:.06em;color:#a09890}" +
    ".soy-sw-prod{display:flex;gap:11px;align-items:center;padding:11px 18px;background:#faf9f7;" +
    "border-bottom:1px solid #f2efea}" +
    ".soy-sw-prod img{width:44px;height:56px;object-fit:cover;flex:0 0 auto;background:#f2efea}" +
    ".soy-sw-prod-title{margin:0 0 2px;font-size:12.5px;font-weight:600;line-height:1.35}" +
    ".soy-sw-prod-meta{margin:0 0 3px;font-size:10.5px;letter-spacing:.04em;color:#a09890}" +
    ".soy-sw-prod-link{font-size:11px;color:#1a1a1a;text-decoration:underline}" +
    ".soy-sw-msgs{display:flex;flex-direction:column;gap:9px;padding:14px 18px;" +
    "max-height:300px;overflow-y:auto}" +
    ".soy-sw-bub{max-width:82%;padding:9px 11px;font-size:13px;line-height:1.55;white-space:pre-line}" +
    ".soy-sw-bub span{display:block;margin-top:5px;font-size:9.5px;letter-spacing:.04em;opacity:.65}" +
    ".soy-sw-bub--me{align-self:flex-end;background:#f2f0ec;color:#3d3833}" +
    ".soy-sw-bub--us{align-self:flex-start;background:#1a1a1a;color:#fff}" +
    ".soy-sw-reply{display:flex;gap:8px;align-items:flex-end;padding:11px 18px 14px;" +
    "border-top:1px solid #f2efea}" +
    ".soy-sw-reply textarea{flex:1 1 auto;box-sizing:border-box;padding:9px 11px;border:1px solid #ddd6cd;" +
    "font-family:inherit;font-size:13px;line-height:1.45;color:#1a1a1a;resize:none;max-height:96px;border-radius:0}" +
    ".soy-sw-reply textarea:focus{outline:none;border-color:#1a1a1a}" +
    ".soy-sw-reply button{flex:0 0 auto;width:38px;height:38px;border:none;background:#1a1a1a;color:#fff;" +
    "cursor:pointer;display:flex;align-items:center;justify-content:center}" +
    ".soy-sw-reply button[disabled]{opacity:.45;cursor:default}" +
    ".soy-sw-reply button svg{width:17px;height:17px}" +
    ".soy-sw-note{margin:0;padding:12px 18px 15px;border-top:1px solid #f2efea;font-size:11.5px;" +
    "line-height:1.55;color:#8a827a}" +
    ".soy-sw-err{margin:0;padding:0 18px 12px;font-size:12px;line-height:1.5;color:#a33a2a}" +
    "@media (max-width:600px){" +
    "#soy-sw-panel{right:0;left:0;bottom:0;width:auto;max-width:none;max-height:90vh;overflow-y:auto;" +
    "border-left:none;border-right:none;border-bottom:none}" +
    // mobilde iç içe kaydırma olmasın: panel tek parça kayar
    "#soy-sw-history,.soy-sw-msgs{max-height:none}" +
    "#soy-sw-btn{right:14px;bottom:14px}}" +
    "@media (prefers-reduced-motion:reduce){#soy-sw-btn{transition:none}}";

  var style = document.createElement("style");
  style.textContent = css;
  document.head.appendChild(style);

  // ------------------------------------------------------------------ işaret
  var ICON_CHAT =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" ' +
    'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    '<path d="M21 11.5a8.4 8.4 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.4 8.4 0 0 1-3.8-.9L3 21l1.9-5.7a8.4 8.4 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.4 8.4 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/></svg>';
  var ICON_CLOSE =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" ' +
    'stroke-linecap="round" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12"/></svg>';
  var ICON_CHECK =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" ' +
    'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    '<circle cx="12" cy="12" r="9"/><path d="m8.5 12.2 2.4 2.4 4.6-4.9"/></svg>';
  var ICON_SEND =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" ' +
    'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    '<path d="M4 12h13M12 5l7 7-7 7"/></svg>';

  // -------------------------------------------------------------------- DOM
  var btn = document.createElement("button");
  btn.id = "soy-sw-btn";
  btn.type = "button";
  btn.setAttribute("aria-label", "Bize soru sor");
  btn.setAttribute("aria-expanded", "false");
  btn.innerHTML = ICON_CHAT;

  var panel = document.createElement("div");
  panel.id = "soy-sw-panel";
  panel.setAttribute("role", "dialog");
  panel.setAttribute("aria-modal", "false");
  panel.setAttribute("aria-labelledby", "soy-sw-title");

  var contextNote = cfg.productTitle
    ? '<p class="soy-sw-ctx">Sorunuz bu ürünle ilişkilendirilecek:<br><strong>' +
      escapeHtml(cfg.productTitle) +
      "</strong></p>"
    : "";

  var identityFields = isLoggedIn
    ? ""
    : '<div class="soy-sw-field"><label for="soy-sw-name">Adınız</label>' +
      '<input id="soy-sw-name" type="text" autocomplete="name" maxlength="120"></div>' +
      '<div class="soy-sw-field"><label for="soy-sw-email">E-posta adresiniz</label>' +
      '<input id="soy-sw-email" type="email" autocomplete="email" required></div>';

  var tabsMarkup = canSeeHistory
    ? '<div id="soy-sw-tabs" role="tablist">' +
      '<button class="soy-sw-tab" id="soy-sw-tab-ask" role="tab" type="button" aria-selected="true">Soru Sor</button>' +
      '<button class="soy-sw-tab" id="soy-sw-tab-mine" role="tab" type="button" aria-selected="false">Sorularım</button>' +
      "</div>"
    : "";

  panel.innerHTML =
    '<div id="soy-sw-head">' +
    '<div><h2 id="soy-sw-title">' +
    (firstName ? "Merhaba " + escapeHtml(firstName) : "Bize Sorun") +
    "</h2>" +
    '<p id="soy-sw-sub">Sorunuzu bırakın, yanıtımızı e-posta ile gönderelim.</p></div>' +
    '<button id="soy-sw-close" type="button" aria-label="Kapat">' + ICON_CLOSE + "</button>" +
    "</div>" +
    tabsMarkup +
    '<div id="soy-sw-history" role="tabpanel" hidden></div>' +
    '<div id="soy-sw-thread" hidden></div>' +
    '<div id="soy-sw-done" hidden></div>' +
    '<div id="soy-sw-body">' +
    contextNote +
    identityFields +
    '<div class="soy-sw-field"><label for="soy-sw-msg">Sorunuz</label>' +
    '<textarea id="soy-sw-msg" maxlength="2000" required ' +
    'placeholder="Örn. 54-56 beden kalıbı nasıl, rahat kullanılır mı?"></textarea></div>' +
    '<label class="soy-sw-consent"><input id="soy-sw-consent" type="checkbox">' +
    "<span>Sorumu yanıtlamak için iletişim bilgilerimin kullanılmasını kabul ediyorum. " +
    '<a href="/pages/kvkk-aydinlatma-metni" target="_blank" rel="noopener">Aydınlatma metni</a></span></label>' +
    '<input id="soy-sw-hp" type="text" tabindex="-1" autocomplete="off" aria-hidden="true">' +
    '<button id="soy-sw-submit" type="button">Gönder</button>' +
    '<p id="soy-sw-error" hidden></p>' +
    "</div>";

  document.body.appendChild(btn);
  document.body.appendChild(panel);

  var body = panel.querySelector("#soy-sw-body");
  var msgEl = panel.querySelector("#soy-sw-msg");
  var consentEl = panel.querySelector("#soy-sw-consent");
  var submitEl = panel.querySelector("#soy-sw-submit");
  var errorEl = panel.querySelector("#soy-sw-error");
  var hpEl = panel.querySelector("#soy-sw-hp");
  var nameEl = panel.querySelector("#soy-sw-name");
  var emailEl = panel.querySelector("#soy-sw-email");
  var historyEl = panel.querySelector("#soy-sw-history");
  var threadEl = panel.querySelector("#soy-sw-thread");
  var doneEl = panel.querySelector("#soy-sw-done");
  var subEl = panel.querySelector("#soy-sw-sub");
  var tabAskEl = panel.querySelector("#soy-sw-tab-ask");
  var tabMineEl = panel.querySelector("#soy-sw-tab-mine");

  // ------------------------------------------------------------------ durum
  var historyItems = [];
  var historyLoaded = false;
  var historyLoading = false;
  var activeItem = null;

  // ------------------------------------------------------------ görünümler
  function showView(name) {
    body.hidden = name !== "ask";
    historyEl.hidden = name !== "mine";
    threadEl.hidden = name !== "thread";
    doneEl.hidden = name !== "done";
    // "thread" de "Sorularım"ın alt görünümü — sekme seçili kalır
    var onMine = name === "mine" || name === "thread";
    if (tabAskEl) tabAskEl.setAttribute("aria-selected", onMine ? "false" : "true");
    if (tabMineEl) tabMineEl.setAttribute("aria-selected", onMine ? "true" : "false");
    if (subEl) {
      subEl.textContent =
        name === "thread"
          ? "Yanıtlarımız burada ve e-postanızda görünür."
          : "Sorunuzu bırakın, yanıtımızı e-posta ile gönderelim.";
    }
    if (name === "mine") {
      if (historyLoaded) renderHistory();
      else loadHistory();
    }
  }

  // ---------------------------------------------------- konuşma listesi
  function loadHistory() {
    if (historyLoading) return;
    historyLoading = true;
    if (!historyEl.hidden) historyEl.innerHTML = '<p class="soy-sw-empty">Yükleniyor…</p>';
    var url =
      cfg.apiUrl +
      "/api/public/questions/mine?store_id=" +
      encodeURIComponent(cfg.storeId) +
      "&customer_id=" +
      encodeURIComponent(cfg.customerId) +
      "&ts=" +
      encodeURIComponent(cfg.customerTs) +
      "&sig=" +
      encodeURIComponent(cfg.customerSig);

    return fetch(url)
      .then(function (res) {
        if (!res.ok) throw new Error("liste alınamadı");
        return res.json();
      })
      .then(function (data) {
        historyItems = (data && data.items) || [];
        historyLoaded = true;
        historyLoading = false;
        if (!historyEl.hidden) renderHistory();
      })
      .catch(function () {
        historyLoading = false;
        if (!historyEl.hidden) {
          historyEl.innerHTML =
            '<p class="soy-sw-empty">Sorularınız şu anda getirilemedi.<br>Lütfen sonra tekrar bakın.</p>';
        }
      });
  }

  function statusBadge(it) {
    if (it.status === "closed")
      return '<span class="soy-sw-badge soy-sw-badge--closed">Kapatıldı</span>';
    if (it.awaiting_answer)
      return '<span class="soy-sw-badge soy-sw-badge--wait">Yanıt bekleniyor</span>';
    return '<span class="soy-sw-badge soy-sw-badge--done">Yanıtlandı</span>';
  }

  function lastText(it) {
    var thread = it.thread || [];
    var last = thread[thread.length - 1];
    if (!last) return "";
    return (last.role === "staff" ? "Yanıtımız: " : "") + last.text;
  }

  function renderHistory() {
    if (!historyItems.length) {
      historyEl.innerHTML =
        '<p class="soy-sw-empty">Henüz soru sormadınız.<br>Merak ettiğinizi "Soru Sor" sekmesinden iletin.</p>';
      return;
    }
    historyEl.innerHTML = historyItems
      .map(function (it, idx) {
        var img = imageUrl(it.product_image);
        return (
          '<button class="soy-sw-row" type="button" data-idx="' + idx + '">' +
          (img ? '<img src="' + escapeAttr(img) + '" alt="" loading="lazy">' : "") +
          '<span class="soy-sw-row-body">' +
          '<span class="soy-sw-row-title">' +
          escapeHtml(it.product_title || "Genel soru") +
          "</span>" +
          '<span class="soy-sw-row-snip">' + escapeHtml(lastText(it)) + "</span>" +
          '<span class="soy-sw-row-meta">' +
          statusBadge(it) +
          "<span>" + escapeHtml(formatDate(it.last_message_at || it.created_at)) + "</span>" +
          "</span></span>" +
          '<span class="soy-sw-row-chev" aria-hidden="true">›</span>' +
          "</button>"
        );
      })
      .join("");
  }

  historyEl.addEventListener("click", function (e) {
    var row = e.target.closest(".soy-sw-row");
    if (!row) return;
    var item = historyItems[Number(row.dataset.idx)];
    if (item) openThread(item);
  });

  // ------------------------------------------------------- tek konuşma
  function openThread(item) {
    activeItem = item;
    renderThread();
    showView("thread");
    scrollMessagesToEnd();
  }

  function renderThread() {
    var it = activeItem;
    if (!it) return;
    var img = imageUrl(it.product_image);
    var productCard = it.product_title
      ? '<div class="soy-sw-prod">' +
        (img ? '<img src="' + escapeAttr(img) + '" alt="">' : "") +
        '<div><p class="soy-sw-prod-title">' + escapeHtml(it.product_title) + "</p>" +
        (it.product_sku ? '<p class="soy-sw-prod-meta">' + escapeHtml(it.product_sku) + "</p>" : "") +
        (it.product_handle
          ? '<a class="soy-sw-prod-link" href="/products/' +
            escapeAttr(encodeURIComponent(it.product_handle)) +
            '">Ürüne git ›</a>'
          : "") +
        "</div></div>"
      : "";

    var bubbles = (it.thread || [])
      .map(function (m) {
        var mine = m.role !== "staff";
        return (
          '<div class="soy-sw-bub ' + (mine ? "soy-sw-bub--me" : "soy-sw-bub--us") + '">' +
          escapeHtml(m.text || "") +
          "<span>" + escapeHtml(formatStamp(m.created_at)) + "</span></div>"
        );
      })
      .join("");

    var footer = it.can_reply
      ? '<div class="soy-sw-reply">' +
        '<textarea id="soy-sw-reply-msg" rows="1" maxlength="2000" ' +
        'placeholder="Bir şey daha sor…" aria-label="Yeni mesajınız"></textarea>' +
        '<button id="soy-sw-reply-send" type="button" aria-label="Gönder">' + ICON_SEND + "</button>" +
        "</div>" +
        '<p class="soy-sw-err" id="soy-sw-reply-err" hidden></p>'
      : '<p class="soy-sw-note">Bu konuşma kapatıldı. Yeni bir konu için ' +
        '"Soru Sor" sekmesini kullanabilirsiniz.</p>';

    threadEl.innerHTML =
      '<div class="soy-sw-thread-top">' +
      '<button class="soy-sw-back" type="button" id="soy-sw-back">‹ Tüm sorularım</button>' +
      '<span class="soy-sw-ticket">' + escapeHtml(it.ticket_no || "") + "</span></div>" +
      productCard +
      '<div class="soy-sw-msgs" id="soy-sw-msgs">' + bubbles + "</div>" +
      footer;

    threadEl.querySelector("#soy-sw-back").addEventListener("click", function () {
      renderHistory();
      showView("mine");
    });
    var sendEl = threadEl.querySelector("#soy-sw-reply-send");
    if (sendEl) {
      var replyEl = threadEl.querySelector("#soy-sw-reply-msg");
      sendEl.addEventListener("click", sendReply);
      replyEl.addEventListener("input", function () {
        replyEl.style.height = "auto";
        replyEl.style.height = Math.min(replyEl.scrollHeight, 96) + "px";
      });
      replyEl.addEventListener("keydown", function (e) {
        if ((e.metaKey || e.ctrlKey) && e.key === "Enter") sendReply();
      });
    }
  }

  function scrollMessagesToEnd() {
    var box = threadEl.querySelector("#soy-sw-msgs");
    if (box) box.scrollTop = box.scrollHeight;
  }

  function sendReply() {
    var replyEl = threadEl.querySelector("#soy-sw-reply-msg");
    var sendEl = threadEl.querySelector("#soy-sw-reply-send");
    var errEl = threadEl.querySelector("#soy-sw-reply-err");
    if (!replyEl || !activeItem) return;
    errEl.hidden = true;

    var text = (replyEl.value || "").trim();
    if (text.length < 5) {
      errEl.textContent = "Lütfen mesajınızı yazın.";
      errEl.hidden = false;
      replyEl.focus();
      return;
    }
    sendEl.disabled = true;

    fetch(cfg.apiUrl + "/api/public/questions/reply", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        store_id: cfg.storeId,
        question_id: activeItem.id,
        customer_id: cfg.customerId,
        ts: cfg.customerTs,
        sig: cfg.customerSig,
        message: text,
      }),
    })
      .then(function (res) {
        return res.json().then(function (data) {
          return { ok: res.ok, data: data };
        });
      })
      .then(function (r) {
        if (!r.ok) throw new Error((r.data && r.data.detail) || "Mesajınız gönderilemedi.");
        // Sunucu güncel diziyi döner — listedeki aynı nesneyi tazeleriz,
        // böylece geri dönünce satır da güncel görünür.
        activeItem.thread = (r.data && r.data.thread) || activeItem.thread;
        activeItem.awaiting_answer = true;
        activeItem.status = "new";
        renderThread();
        scrollMessagesToEnd();
      })
      .catch(function (err) {
        sendEl.disabled = false;
        errEl.textContent = err.message || "Bağlantı kurulamadı. Lütfen tekrar deneyin.";
        errEl.hidden = false;
      });
  }

  // ------------------------------------------------------------ yardımcılar
  function imageUrl(path) {
    if (!path) return "";
    return /^https?:/i.test(path) ? path : cfg.apiUrl + path;
  }

  function toDate(iso) {
    if (!iso) return null;
    var d = new Date(iso.slice(-1) === "Z" ? iso : iso + "Z");
    return isNaN(d) ? null : d;
  }

  function formatDate(iso) {
    var d = toDate(iso);
    if (!d) return "";
    return d.toLocaleDateString("tr-TR", { day: "numeric", month: "long", year: "numeric" });
  }

  function formatStamp(iso) {
    var d = toDate(iso);
    if (!d) return "";
    return d.toLocaleString("tr-TR", {
      day: "numeric",
      month: "short",
      hour: "2-digit",
      minute: "2-digit",
    });
  }

  function escapeHtml(text) {
    var div = document.createElement("div");
    div.textContent = text == null ? "" : text;
    return div.innerHTML;
  }

  function escapeAttr(text) {
    return escapeHtml(text).replace(/"/g, "&quot;").replace(/'/g, "&#39;");
  }

  // ------------------------------------------------------------------ olaylar
  if (tabAskEl) tabAskEl.addEventListener("click", function () { showView("ask"); });
  if (tabMineEl) tabMineEl.addEventListener("click", function () { showView("mine"); });

  function threadForCurrentProduct() {
    if (!cfg.productHandle) return null;
    for (var i = 0; i < historyItems.length; i++) {
      // en yeni kayıt önce gelir (sunucu created_at DESC sıralar)
      if (historyItems[i].product_handle === cfg.productHandle && historyItems[i].can_reply) {
        return historyItems[i];
      }
    }
    return null;
  }

  function open() {
    panel.setAttribute("data-open", "");
    btn.setAttribute("aria-expanded", "true");
    // Ürün sayfasında o ürün için açık bir konuşma varsa doğrudan onu göster
    var existing = threadForCurrentProduct();
    if (existing) {
      openThread(existing);
      return;
    }
    showView("ask");
    setTimeout(function () {
      (nameEl || msgEl).focus();
    }, 40);
  }
  function close() {
    panel.removeAttribute("data-open");
    btn.setAttribute("aria-expanded", "false");
    btn.focus();
  }
  btn.addEventListener("click", function () {
    panel.hasAttribute("data-open") ? close() : open();
  });
  panel.querySelector("#soy-sw-close").addEventListener("click", close);
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && panel.hasAttribute("data-open")) close();
  });

  submitEl.addEventListener("click", submit);
  msgEl.addEventListener("keydown", function (e) {
    // Cmd/Ctrl+Enter ile gönder
    if ((e.metaKey || e.ctrlKey) && e.key === "Enter") submit();
  });

  function showError(text) {
    errorEl.textContent = text;
    errorEl.hidden = false;
  }

  function submit() {
    errorEl.hidden = true;
    var message = (msgEl.value || "").trim();
    if (message.length < 5) {
      showError("Lütfen sorunuzu yazın.");
      msgEl.focus();
      return;
    }
    if (!isLoggedIn) {
      var email = (emailEl.value || "").trim();
      if (!email || email.indexOf("@") < 1) {
        showError("Yanıtı gönderebilmemiz için geçerli bir e-posta adresi gerekli.");
        emailEl.focus();
        return;
      }
    }
    if (!consentEl.checked) {
      showError("Devam etmek için onay kutusunu işaretleyin.");
      consentEl.focus();
      return;
    }

    var payload = {
      store_id: cfg.storeId,
      message: message,
      consent: true,
      website: hpEl.value || null,
      page_url: location.href.slice(0, 1000),
    };
    if (isLoggedIn) {
      payload.shopify_customer_id = cfg.customerId;
      if (cfg.customerName) payload.name = cfg.customerName;
    } else {
      payload.name = (nameEl.value || "").trim() || null;
      payload.email = (emailEl.value || "").trim();
    }
    if (cfg.productId) payload.product_id = cfg.productId;
    if (cfg.productHandle) payload.product_handle = cfg.productHandle;
    if (cfg.productTitle) payload.product_title = cfg.productTitle;

    submitEl.disabled = true;
    submitEl.textContent = "Gönderiliyor…";

    fetch(cfg.apiUrl + "/api/public/questions", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    })
      .then(function (res) {
        return res.json().then(function (data) {
          return { ok: res.ok, status: res.status, data: data };
        });
      })
      .then(function (r) {
        if (!r.ok) {
          throw new Error(
            (r.data && r.data.detail) ||
              "Sorunuz gönderilemedi. Lütfen daha sonra tekrar deneyin."
          );
        }
        showDone(r.data && r.data.ticket_no);
      })
      .catch(function (err) {
        submitEl.disabled = false;
        submitEl.textContent = "Gönder";
        showError(err.message || "Bağlantı kurulamadı. Lütfen tekrar deneyin.");
      });
  }

  function showDone(ticketNo) {
    // Form ayakta kalır (innerHTML ezilmez) — müşteri aynı oturumda tekrar sorabilir
    msgEl.value = "";
    consentEl.checked = false;
    submitEl.disabled = false;
    submitEl.textContent = "Gönder";
    historyLoaded = false; // yeni soru "Sorularım"da görünsün

    doneEl.innerHTML =
      ICON_CHECK +
      "<h3>Sorunuz bize ulaştı</h3>" +
      "<p>En kısa sürede e-posta ile yanıtlayacağız." +
      (ticketNo ? "<br>Talep no: <strong>" + escapeHtml(ticketNo) + "</strong>" : "") +
      (canSeeHistory
        ? '<br>Yanıtı <strong>Sorularım</strong> sekmesinden de görebilir, oradan konuşmaya devam edebilirsiniz.'
        : "") +
      "</p>" +
      (canSeeHistory
        ? '<button class="soy-sw-linkbtn" type="button" id="soy-sw-goto-mine">Sorularıma git</button>'
        : '<button class="soy-sw-linkbtn" type="button" id="soy-sw-ask-again">Başka bir soru sor</button>');
    showView("done");

    var gotoMine = doneEl.querySelector("#soy-sw-goto-mine");
    if (gotoMine) gotoMine.addEventListener("click", function () { showView("mine"); });
    var askAgain = doneEl.querySelector("#soy-sw-ask-again");
    if (askAgain) askAgain.addEventListener("click", function () { showView("ask"); });
  }

  // Ürün sayfasında geçmişi önden çekeriz: balona basıldığı anda o ürünün
  // konuşmasını AÇABİLMEK için liste elde olmalı (sonradan görünüm değiştirmek
  // sıçrama yaratır). Diğer sayfalarda sekmeye basılınca yüklenir.
  if (canSeeHistory && cfg.productHandle) loadHistory();
})();
